/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { BaseDesignRestService } from '@gh/builder-shared-data';
import { EntityInputDialogConfig } from '@gh/common-internal-shared';
import { getRouteParam, InitDialogViewService, InitViewService } from '@gh/common-shared';
import { mapSlicedDataItems, SlicedDataSource } from '@gh/core-data';
import { DialogRouteSnapshot } from '@gh/core-ui';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import {
  BaseDesignCheckUsage,
  BaseDesignFilter,
  baseDesignFromDto,
  BaseDesignListItem,
  baseDesignToDto,
} from './base-design.model';

@Injectable()
export class BaseDesignBusinessService
  implements InitViewService, InitDialogViewService<EntityInputDialogConfig<BaseDesignListItem>> {

  constructor(private restService: BaseDesignRestService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      dataSource: this.findAllAsDataSource(),
    };
  }

  initDialogView(route: DialogRouteSnapshot<EntityInputDialogConfig<BaseDesignListItem>>): any {
    return route.input;
  }

  initDetailsView(route: ActivatedRouteSnapshot): any {
    return {
      baseDesignDetails: this.restService.get(getRouteParam(route, 'baseDesignId')),
    };
  }

  findAllAsDataSource(filter?: BaseDesignFilter): SlicedDataSource<BaseDesignListItem> {
    return mapSlicedDataItems(this.restService.findAllAsDataSource(filter), baseDesignFromDto);
  }

  create(baseDesign: BaseDesignListItem): Observable<BaseDesignListItem> {
    return this.restService.create(baseDesignToDto(baseDesign)).pipe(map$(baseDesignFromDto));
  }

  update(baseDesign: BaseDesignListItem): Observable<BaseDesignListItem> {
    return this.restService.update(baseDesignToDto(baseDesign)).pipe(map$(baseDesignFromDto));
  }

  undelete(baseDesign: BaseDesignListItem): Observable<BaseDesignListItem> {
    return this.restService.undelete(baseDesignToDto(baseDesign)).pipe(map$(baseDesignFromDto));
  }

  deactivateOrDelete(baseDesign: BaseDesignListItem,
                     checkUsage: BaseDesignCheckUsage): Observable<BaseDesignListItem> {
    return this.restService.deactivateOrDelete(baseDesignToDto(baseDesign), checkUsage).pipe(map$(baseDesignFromDto));
  }

  checkUsage(baseDesign: BaseDesignListItem): Observable<BaseDesignCheckUsage> {
    return this.restService.checkUsage(baseDesign);
  }
}
